import { KeyboardEvent, useRef } from "react";

import { Input } from "ui/core/input";

export const InputIME = (
  props: React.InputHTMLAttributes<HTMLInputElement>
) => {
  const lockRef = useRef(false); // 用來判斷 IME 輸入法是否還在選字

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Escape" && e.key !== "Enter") return;

    // 因為 IME 輸入法在 Composing 時按下 Escape 會觸發兩次 onKeyDown
    // 一次為 Composing=true，一次為 Composing=false
    // 這邊要過濾掉 Composing=true 時的 Escape
    if (e.key === "Escape" && e.nativeEvent.isComposing) return;

    // 如果還在選字，就不要發送
    if (lockRef.current) return (lockRef.current = false);

    // 終於可以發送了
    props.onKeyDown?.(e);
  };

  return (
    <Input
      {...props}
      onKeyDown={handleKeyDown}
      onChange={(e) => {
        e.preventDefault();
        props.onChange?.(e);
      }}
      onCompositionStart={() => {
        lockRef.current = true;
      }}
    />
  );
};
